<div class="topnav-container">
    <app-topnav></app-topnav>
</div>
<div class="body-container">
    <div>
        <router-outlet></router-outlet>
    </div>
</div>